var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconNoWishlist = function SvgIconNoWishlist(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104,
    height: 105,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 104,
    y: 0.5,
    rx: 52
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M52.002 37.557c4.698-4.217 11.958-4.077 16.483.458 4.526 4.534 4.681 11.759.472 16.471L52 71.47 35.043 54.486c-4.209-4.712-4.052-11.948.472-16.471 4.528-4.529 11.775-4.681 16.487-.458"
  })));
};
export default SvgIconNoWishlist;